import { IconSVG } from '../types';

export const Play = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      style={style}
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M6 18.704V5.296c0-.368.13-.675.389-.924a1.27 1.27 0 011.247-.323c.118.032.232.08.34.145L18.534 10.9c.195.13.34.291.438.486.097.194.145.4.145.615 0 .216-.048.421-.145.615a1.254 1.254 0 01-.438.486L7.976 19.806a1.35 1.35 0 01-.68.194 1.27 1.27 0 01-.907-.372A1.227 1.227 0 016 18.704z"
      />
    </svg>
  );
};
